module.exports = __webpack_public_path__ + "static/media/salja.30fb1cd0.mp3";